import { Fragment } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { Asset, kuiperClassNames } from '@opallabs/kuiper'
import { TwitterSingleFooter } from '../../../sharedDisplays/footers/TwitterSingleFooter'
import { TwitterSingleHeader } from '../../../sharedDisplays/headers/TwitterSingleHeader'
import { assetStyles } from '../../styles'

export interface Props {
  accountImage: AssetReference | null
  accountName: string
  accountUsername: string
  content: string
  display: string
  gif?: AssetReference
  isAccountPremium?: boolean
  isPresenting: boolean
  onContentChange: (val: string) => void
  onExpandAsset: (assetId: number) => void
  onRemoveAsset: (assetId: number) => void
  postType: string
  readOnly: boolean
  scheduledAt: string
  timezone: string
  updateCaption?: () => void
}

export const Single: React.FC<Props> = ({
  accountImage,
  accountName,
  accountUsername,
  content,
  display = 'mobileSingle',
  gif,
  isAccountPremium,
  isPresenting,
  onContentChange,
  onExpandAsset,
  onRemoveAsset,
  readOnly,
  scheduledAt,
  timezone,
  updateCaption,
}) => {
  return (
    <Fragment>
      <TwitterSingleHeader
        accountImage={accountImage}
        accountName={accountName}
        accountUsername={accountUsername}
        content={content}
        isAccountPremium={isAccountPremium}
        isMobile={display.includes('mobile')}
        onContentChange={onContentChange}
        readOnly={readOnly}
      />
      <div
        css={assetStyles.getAssetContainerStyles(display)}
        className={kuiperClassNames('twitter-gif-asset-container')}
      >
        {gif && (
          <Fragment>
            <Asset
              imageFit="cover"
              hasAssetOverlay={Boolean(gif) && (!readOnly || isPresenting)}
              assetReference={gif}
              placeholder={true}
              hasAssetOptions={true}
              removeable={!isPresenting}
              onEmbiggen={() => onExpandAsset(gif.id || 0)}
              onRemove={() => onRemoveAsset(gif.id || 0)}
              overrideStyles={assetStyles.getAssetStyles(gif, display)}
              updateCaption={updateCaption}
            />
            <div css={assetStyles.gifLabelStyles}>GIF</div>
          </Fragment>
        )}
      </div>
      <TwitterSingleFooter
        isMobile={display.includes('mobile')}
        scheduledAt={scheduledAt}
        timezone={timezone}
      />
    </Fragment>
  )
}
